import React from 'react'
import { Routes, Route, Navigate } from "react-router";
import Dashboard from "../screens/Dashboard";
import Products from "../screens/Products";
import ProductAdd from "../screens/ProductAdd";
import Categories from "../screens/Categories";
import AddCategory from "../screens/AddCategory";
import EditCategory from "../screens/EditCategory";
import Orders from "../screens/Orders";
import EditOrder from "../Components/Orders/EditOrder";
import AddOrder from "../Components/Orders/AddOrder";
import ViewOrder from "../Components/Orders/ViewOrder";
import Users from "../screens/Users";
import AddUser from "../Components/Users/AddUser";
import EditUser from "../Components/Users/EditUser";
import Vendors from "../screens/Vendors";
import AddVendor from "../Components/Vendors/AddVendor";
import EditVendor from "../Components/Vendors/EditVendor";
import ViewVendor from "../Components/Vendors/ViewVendor";
import Suppliers from "../screens/Suppliers";
import AddSupplier from "../Components/Suppliers/AddSupplier";
import EditSupplier from "../Components/Suppliers/EditSupplier";
import LoginPage from "../Components/Login";
import OrderDetail from '../Components/Orders/OrderDetails';
import Setting from '../screens/Setting';
import QueryDisplay from '../screens/QueryDisplay';
import Query from '../screens/Query';


const AdminRoutes = () => {
    return (
        <>

            <Route path="/" element={<Dashboard />} />
            <Route path="/products" element={<Products />} />
            <Route path="/product/add" element={<ProductAdd />} />
            <Route path="/categories" element={<Categories />} />
            <Route path="/add-category" element={<AddCategory />} />
            <Route path="/edit-category" element={<EditCategory />} />
            <Route path="/orders" element={<Orders />} />
            <Route path="/order/add-order" element={<AddOrder />} />
            <Route path="/order/edit-order" element={<EditOrder />} />
            {/* <Route path="/order/view-order" element={<ViewOrder />} /> */}
            <Route path="/order/view-order" element={<OrderDetail />} />
            <Route path="/users" element={<Users />} />
            <Route path="/user/add-user" element={<AddUser />} />
            <Route path="/user/edit-user" element={<EditUser />} />
            <Route path="/vendors" element={<Vendors />} />
            <Route path="/vendor/add-vendor" element={<AddVendor />} />
            <Route path="/vendor/edit-vendor" element={<EditVendor />} />
            <Route path="/vendor/view-vendor" element={<ViewVendor />} />
            <Route path="/suppliers" element={<Suppliers />} />
            <Route path="/supplier/add-supplier" element={<AddSupplier />} />
            <Route path="/supplier/edit-supplier" element={<EditSupplier />} />
            <Route path="/setting" element={<Setting />} />
            <Route path="/inquiries" element={<Query />} />

        </>
    )
}

export default AdminRoutes
